<template>
	<div>
		<Card>
			<div class="info">
				<h3>Voting breakdown</h3>
				<p>
					Use this table to examine the total number of votes cast from each
					unique IP address for the campaign and date range selected.
				</p>
				<p>Some strong indicators of fraudulent behaviour are:</p>
				<ul>
					<li>
						An abnormally high number of sessions compared to other IP addresses
					</li>
					<li>Significantly more sessions started than completed</li>
				</ul>
				<Note
					>Blocking an IP address here will invalidate all votes cast from that
					IP address across all campaigns.</Note
				>
			</div>
			<StrapiList :source="source">
				<template v-slot="list">
					<IPAddressesTable v-bind="list" />
				</template>
			</StrapiList>
		</Card>
	</div>
</template>

<script>
import Card from '@/components/shared/Card'
import StrapiList from '@/components/admin/StrapiList'
import IPAddressesTable from '@/components/admin/IPAddressesTable'
import Note from '@/components/admin/Note'

export default {
	name: 'ModerateCampaign',
	computed: {
		source() {
			return `/campaigns/${this.$route.params.id}/ips`
		}
	},
	components: {
		Card,
		StrapiList,
		IPAddressesTable,
		Note
	}
}
</script>

<style lang="scss" scoped>
.info {
	margin-bottom: 2rem;
	> :first-child {
		margin-top: 0;
	}
	> :last-child {
		margin-bottom: 0;
	}
	ul {
		padding-left: 2rem;
	}
}
</style>
